// extracted by mini-css-extract-plugin
module.exports = {"A_banner":"A_A_banner__1BcLf"};